import React from "react";
import { Link } from "react-router-dom";

/* ======================================== COMPONENT ======================================== */

const CategoryLink = ({ to, children, ...props }) => {

  //If navigating to rolex pages, we want to exit out of the SPA (external link)
  if (to && to.toLowerCase().includes("en/rolex")) {
    return (
      <a
        href={to}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={to}
      {...props}
    >
      {children}
    </Link>
  );
};

export default CategoryLink;